import React, { useEffect, useState } from "react";
import useStyles from "../styles";
import {
  InputLabel,
  FormControl,
  Grid,
  TextField,
  Container,
  Typography,
  Button,
  Box,
  useMediaQuery,
} from "@material-ui/core";
import { USER_PROP } from "components/User/constants";
import settingsActions from "../actions";
import { useSelector } from "react-redux";
import { checkFieldValid, checkEmailValid } from "components/User/Validation";

const ProfileTab = () => {
  const classes = useStyles();
  const { user, inviter } = useSelector((state) => state.settings.profile);
  const { profile } = useSelector((state) => state.settings);
  const { aboutMe,
    setProfileData, 
    updateMe,
  } = settingsActions();
  const [isFormValid, setIsFormValid] = useState(true);
  const textfields = [
    USER_PROP.EMAIL,
    USER_PROP.FNAME,
    USER_PROP.ROLE,
    USER_PROP.ABOUT,  // currently not used
  ];

  const [fieldChecked, setFieldChecked] = useState({
    ...Object.fromEntries(textfields.map((each) => [[each], false])),
  });

  useEffect(() => { // currently not used
    aboutMe();
  }, [aboutMe]);

  useEffect(() => {
    checkFormValidity();
  });

  const checkFormValidity = () => {
    const checkFields =
      checkEmailValid(user[USER_PROP.EMAIL]) && !!user[USER_PROP.FNAME];

    setIsFormValid(checkFields);
  };
  const matches = useMediaQuery((theme) => theme.breakpoints.up("sm"));

  return (
    <Container>
      <Box m={1}>
        {/* <Grid
          item
          container
          xs={12}
          sm={6}
          direction="row"
          justify={matches ? "flex-start" : "center"}
          alignItems="center"
        >
          <Box my={2}>
            <Avatar className={classes.AvatarSmall}>
              {" "}
              {(user[USER_PROP.FNAME].toUpperCase()[0] || "") +
                (user[USER_PROP.LNAME].toUpperCase()[0] || "")}
            </Avatar>
          </Box>
          <Box m={2}>
            <Typography variant="subtitle1">Upload your photo</Typography>
            <Typography variant="caption">
              Photos help other members recognize you in CuRVE
            </Typography>
          </Box>
        </Grid> */}
        <Grid item sm={6} container xs={12} direction="row">
          <Grid item sm={5} xs={12}>
            <InputLabel size="small">Name</InputLabel>
            <FormControl
              variant="outlined"
              size="small"
              fullWidth
              className={classes.formControl}
            >
              <TextField
                size="small"
                variant="outlined"
                margin="normal"
                required
                fullWidth
                error={
                  fieldChecked[USER_PROP.FNAME] &&
                  !checkFieldValid(USER_PROP.FNAME, user[USER_PROP.FNAME])
                }
                value={user[USER_PROP.FNAME]}
                onClick={() => {
                  setFieldChecked({
                    ...fieldChecked,
                    [USER_PROP.FNAME]: true,
                  });
                }}
                onChange={(e) =>
                  setProfileData({
                    ...profile,
                    user: {
                      ...user,
                      [USER_PROP.FNAME]: e.target.value,
                    },
                  })
                }
              />
            </FormControl>
          </Grid>
          <Grid item sm={7} />
        </Grid>
        <Grid item container sm={6} xs={12} direction="row">
          <Grid item sm={5} xs={12}>
            <InputLabel size="small">Email</InputLabel>
            <FormControl
              variant="outlined"
              size="small"
              fullWidth
              className={classes.formControl}
            >
              <TextField
                size="small"
                variant="outlined"
                margin="normal"
                required
                fullWidth
                value={user[USER_PROP.EMAIL] || ""}
                error={
                  fieldChecked[USER_PROP.EMAIL] &&
                  !checkEmailValid(user[USER_PROP.EMAIL])
                }
                onClick={() => {
                  setFieldChecked({
                    ...fieldChecked,
                    [USER_PROP.EMAIL]: true,
                  });
                }}
                onChange={(e) =>
                  setProfileData({
                    ...profile,
                    user: {
                      ...user,
                      [USER_PROP.EMAIL]: e.target.value,
                    },
                  })
                }
                disabled={user[USER_PROP.EMAIL]?true:false}
              />
            </FormControl>
          </Grid>
          <Grid item sm={2} />
          {/* <Grid item sm={5} xs={12}>
            <InputLabel size="small" className={classes.formControl}>
              Role
            </InputLabel>
            <Grid
              container
              direction="row"
              alignItems="center"
              className={classes.formControl}
            >
              <Grid item xs={8}>
                <FormControl variant="outlined" size="small" fullWidth>
                  <Select
                    className={classes.roleSelection}
                    required
                    size="small"
                    fullWidth
                    value={user[USER_PROP.ROLE]}
                    onChange={(e) =>
                      setProfileData({
                        ...profile,
                        user: {
                          ...user,
                          [USER_PROP.ROLE]: e.target.value,
                        },
                      })
                    }
                  >
                    {Object.keys(UserRole).map((x) => {
                      return (
                        <MenuItem value={UserRole[x]} key={x}>
                          {UserRoleText[x]}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={4}>
                <Button
                  variant="contained"
                  color="primary"
                  disableElevation
                  className={classes.updateButton}
                  onClick={() => {
                    updateRole();
                  }}
                >
                  Update
                </Button>
              </Grid>
            </Grid>
          </Grid> */}
        </Grid>
        {!inviter.type && <Grid item sm={6} container xs={12} direction="row">
          <Grid item sm={5} xs={12} align="right" >
          <Button
              variant="contained"
              color="primary"
              disabled={!isFormValid}
              onClick={() => updateMe()}
            >
              Save Changes
            </Button>
          </Grid>
          {/* <Grid item sm={7} /> */}
        </Grid>}

        {/* currently not used */}
        {/* <Grid item container sm={6} xs={12} direction="row"> 
          <InputLabel size="small" className={classes.formControl}>
            About Me
          </InputLabel>
          <FormControl fullWidth className={classes.formControl}>
            <TextField
              variant="outlined"
              size="small"
              multiline
              rows={5}
              required
              fullWidth
              value={user[USER_PROP.ABOUT] || ""}
              onChange={(e) =>
                setProfileData({
                  ...profile,
                  user: {
                    ...user,
                    [USER_PROP.ABOUT]: e.target.value,
                  },
                })
              }
            />
          </FormControl>
        </Grid> */}
        {inviter.type && <Grid
          item
          container
          xs={12}
          sm={6}
          justify="space-between"
          alignItems="center"
        >
          <Grid item container sm={8} xs={12} direction="column">
            {inviter.type && (
              <Typography variant="subtitle1">
                {`Invite Type: ${inviter.type}`}
              </Typography>
            )}
            {inviter[USER_PROP.FNAME] && (
              <Typography variant="caption">
                {`Invited by ${inviter[USER_PROP.FNAME]} ${
                  inviter[USER_PROP.LNAME]
                } on ${inviter.sent_date}`}
              </Typography>
            )}
          </Grid>
          <Grid
            item
            container
            sm={4}
            xs={12}
            justify={matches ? "flex-end" : "center"}
          >
            <Button
              variant="contained"
              color="primary"
              disabled={!isFormValid}
              onClick={() => updateMe()}
            >
              Save Changes
            </Button>
          </Grid>
        </Grid>}
      </Box>
    </Container>
    // </Grid>
  );
};
export default ProfileTab;
